import React, { useEffect, useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';

const Question1 = props => {
  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <h3 className={`${styles.pageTitle}`}>What is your name?</h3>
        <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
          <label for={`notifiersFirstName`} className={`nsw-form-label ${styles.nswFormLabel}`}>
            Given name
          </label>
          <input
            id={'notifiersFirstName'}
            name={'notifiersFirstName'}
            className={`nsw-form-input ${styles.nswFormInput}`}
            value={props.firstname && props.firstname.length > 0 ? props.firstname : undefined}
            onChange={event => {
              props.setFirstname(event.target.value);
            }}
          />
        </div>
        <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
          <label for={`notifiersLastName`} className={`nsw-form-label ${styles.nswFormLabel}`}>
            Last name
          </label>
          <input
            id={'notifiersLastName'}
            name={'notifiersLastName'}
            className={`nsw-form-input ${styles.nswFormInput}`}
            value={props.lastname && props.lastname.length > 0 ? props.lastname : undefined}
            onChange={event => {
              props.setLastname(event.target.value);
            }}
          />
        </div>
        <div className={styles.btnWrap}>
          <Button
            disabled={!props.firstname || !props.lastname}
            onClick={() => {
              props.setCurrentQuestion(2);
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question1;
